import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Form } from 'semantic-ui-react'

import SeguroPermite from '../../../components/funcionales/seguropermite'

import XLSX from 'xlsx'
import { saveAs } from 'file-saver';

//utils
import queries from '../../../utils/queries'

//dropdown EMPRESAS
const DetalleEmpNivel1 = props => {
  // console.log(props.elemento)
  return (
    <option style={props.styles.input}>{props.elemento.descrEmpresa}</option>
  )
};

const ListaEmp = ({styles, list, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleEmpNivel1 styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="descrEmpresa" id="miLista" onChange={(ev)=>handleChange(ev)}>
        <option value="">Seleccionar Empresa...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown EMPRESAS

//Lista de mecanismos
const DetallePl = ({elemento, indice, handleChange}) => {
  return(
    <tr className=''>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>
        <input style={{margin: '0.4em 0em 0em 0em'}} type='checkbox' name="checkSeleccInf" checked={elemento.checkSeleccInf} onChange={(ev)=>handleChange(ev, indice)}/>
      </td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.nombreUsuario}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrPlanta}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrSeccion}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrEquipo}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrComponente}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrMecanismo}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrMetodo}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrTarea}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrFrecuencia}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.fechaReal}</td>
    </tr>
  )
};
const ListaPl = ({list, handleChange}) => {
    const nivel1Detalle = list.map((elemento, i) => <DetallePl elemento={elemento} key={i} indice={i}
      handleChange={handleChange}/>);
    return(
      <tbody className=''>
        {nivel1Detalle}
      </tbody>
    )
  };

//FIN Lista de mecanismos

class ProgInfProg2 extends React.Component {
  state={list: 
    this.props.allOrdenRtes.allOrdenRtes?this.props.allOrdenRtes.allOrdenRtes.map((elemento, i) => ({
      ...elemento, checkSeleccInf: true
    })):[],
    argsDocum: {descrEmpresa: "Seleccionar Empresa...", desde: this.props.fechaHoy, hasta: this.props.fechaFin},
      permiteUpdate: true, confirmaAct: false, open: false, argsBuscProg: {}, checkSeleccInfAll: true
  }

  handleChange = async (ev, indice) => {
    if(ev.target.name === "checkSeleccInfAll"){
      const list = this.state.list
      let checkSeleccInfAll = this.state.checkSeleccInfAll
      // console.log(checkSeleccInfAll)
      if(checkSeleccInfAll){
        checkSeleccInfAll = false
      }else{
        checkSeleccInfAll = true
      }
      for(let i=0; i<list.length; i++){
        list[i].checkSeleccInf = checkSeleccInfAll
        // console.log(list[i].checkSeleccInf)
      }
      this.setState({checkSeleccInfAll});
      this.setState({list});
    }

    if(ev.target.name === "checkSeleccInf"){
      const list = this.state.list
      let checkSeleccInfAll = this.state.checkSeleccInfAll
      list[indice].checkSeleccInf = ev.target.checked
      checkSeleccInfAll = false
      this.setState({checkSeleccInfAll});
      this.setState({list});
    }    
    
    // console.log(ev.target.name)
    // console.log(ev.target.value)
    if(ev.target.name==="descrEmpresa"||ev.target.name==="desde"||ev.target.name==="hasta"){
      const argsDocum = this.state.argsDocum
      argsDocum[ev.target.name] = ev.target.value
      let argsBuscar=""
      if(ev.target.name==="descrEmpresa"){
        argsBuscar += `'descrEmpresa': '${ev.target.value}'`
      }else{
        argsBuscar += `'descrEmpresa': '${argsDocum.descrEmpresa}'`
      }
      if(this.props.argsBuscProg.descrPlanta){
        argsBuscar += `, 'descrPlanta': /${this.props.argsBuscProg.descrPlanta}/i`
      }
      if(this.props.argsBuscProg.descrSeccion){
        argsBuscar += `, 'descrSeccion': /${this.props.argsBuscProg.descrSeccion}/i`
      }
      if(this.props.argsBuscProg.descrEquipo){
        argsBuscar += `, 'descrEquipo': /${this.props.argsBuscProg.descrEquipo}/i`
      }
      if(this.props.argsBuscProg.descrComponente){
        argsBuscar += `, 'descrComponente': /${this.props.argsBuscProg.descrComponente}/i`
      }
      if(this.props.argsBuscProg.descrMecanismo){
        argsBuscar += `, 'descrMecanismo': /${this.props.argsBuscProg.descrMecanismo}/i`
      }
      if(this.props.argsBuscProg.nombreUsuario){ 
        argsBuscar += `, 'nombreUsuario': /${this.props.argsBuscProg.nombreUsuario}/i`
      }

      let argsBuscarF = ""
      if(ev.target.name==="descrEmpresa"){
        argsBuscarF = `${argsBuscar}, fechaReal: { $gte: new Date('${argsDocum.desde}'), $lte: new Date('${argsDocum.hasta}') }`
      }else{
        if(ev.target.name==="desde"){
          argsBuscarF = `${argsBuscar}, fechaReal: { $gte: new Date('${ev.target.value}'), $lte: new Date('${argsDocum.hasta}') }`
        }else{
          argsBuscarF = `${argsBuscar}, fechaReal: { $gte: new Date('${argsDocum.desde}'), $lte: new Date('${ev.target.value}') }`
        }
      }

    let argsBuscarPl = {tipoqry: `[{$match: {estadoOrden: 'Cerrado', realizado: 'S', ${argsBuscarF}}}]`}
      // let argsBuscarPl = {tipoqry: `[{$match: {estadoOrden: 'Cerrado'}}]`}
console.log(argsBuscarPl) 
      await this.props.allOrdenRtes.refetch(argsBuscarPl)

      if(this.props.allOrdenRtes.allOrdenRtes){
        this.setState({list: this.props.allOrdenRtes.allOrdenRtes
          // this.props.allOrdenRtes.allOrdenRtes?this.props.allOrdenRtes.allOrdenRtes.map((elemento, i) => ({
          //   ...elemento, checkSeleccInf: true

          // })):[]
        })
        this.setState({checkSeleccInfAll: true});
      }
// console.log(this.props.allOrdenRtes)
      this.setState({argsDocum});
    }
  }


  handleSubmit = async (ev, list1, argsDocum)=>{
    console.log(list1.length)
    if(list1.length>0){
      // let list = await list1.filter(elemento => elemento.checkSeleccInf === true)
      let list = list1
      if(list.length>0){
        document.body.style.cursor = 'wait'
      }
      // list.forEach(async(elemento, iiii) => {

      //Archivo Excel
      let xlsString = []
      // console.log(list1)
      let xlsString1 = []
      xlsString1 = ['Ruta', 'OT', 'Frecuencia', 'Fecha prog.', 'Empresa', 'Planta', 'Sección', 'Equipo', 'Componente',
        'Mecanismo', 'Método', 'Tarea', 'Lubricante', 'Cant. prog', 'Und', 'Puntos', 'Min prog.', 'Realizado', 'Fecha real', 'Hora real',
        'Operario real', 'Cant. real', 'Min. real', 'Acum. (Horas/Km)', 'Temperatura antes lub.', 'Temperatura despues lub.', 
        'Ultrasonido antes lub.', 'Ultrasonido despues lub.', 'Vibraciones antes lub.', 'Vibraciones despues lub.', 'Observaciones']
      xlsString.push(xlsString1)
      
      for (let iiii=0;iiii<list.length;iiii++){
        let fechaProg=''
        let campoAgno = ''
        let campoMes = ''
        let campoDia = ''
        if(list[iiii].fechaProg){
          campoAgno = list[iiii].fechaProg.substring(0, 4)
          campoMes = list[iiii].fechaProg.substring(5, 7)
          campoDia = list[iiii].fechaProg.substring(8, 10)
          fechaProg=campoAgno + '-' + campoMes + '-' + campoDia
        }
        let fechaReal=''
        let horaReal=list[iiii].horaReal?list[iiii].horaReal:0
        if(list[iiii].fechaReal){
          campoAgno = list[iiii].fechaReal.substring(0, 4)
          campoMes = list[iiii].fechaReal.substring(5, 7)
          campoDia = list[iiii].fechaReal.substring(8, 10)
          fechaReal=campoAgno + '-' + campoMes + '-' + campoDia
        }
        xlsString1 = [list[iiii].ruta, list[iiii].numeroOrden, list[iiii].descrFrecuencia, fechaProg, list[iiii].descrEmpresa, list[iiii].descrPlanta,
        list[iiii].descrSeccion, list[iiii].descrEquipo, list[iiii].descrComponente, list[iiii].descrMecanismo, 
        list[iiii].descrMetodo, list[iiii].descrTarea, list[iiii].descrLubricante, list[iiii].cantidad, 
        list[iiii].abrevUnidad, list[iiii].puntos, list[iiii].minutos, list[iiii].realizado, fechaReal, horaReal,
        list[iiii].nombreUsuario, list[iiii].cantidadReal, list[iiii].minutosReal, list[iiii].acumulado, 
        list[iiii].tempAntesLub, list[iiii].tempDespuesLub, list[iiii].ultraAntesLub, list[iiii].ultraDespuesLub, list[iiii].vibraAntesLub, list[iiii].vibraDespuesLub, list[iiii].observacionesReal]

        xlsString.push(xlsString1)

        if(iiii===list.length-1){

          var wb = XLSX.utils.book_new();

          wb.Props = {
            Title: "SheetJS Tutorial",
            Subject: "Test",
            Author: "Red Stapler",
            CreatedDate: new Date(2017,12,19)
          };

          wb.SheetNames.push("Ordenes");

          let ws_data = xlsString;

          let ws = XLSX.utils.aoa_to_sheet(ws_data);
          wb.Sheets["Ordenes"] = ws;
          let wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});
          function s2ab(s) { 
            let buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
            let view = new Uint8Array(buf);  //create uint8array as viewer
            for (let i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; //convert to octet
            return buf;    
          }
          saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), 'Matríz_Ordenes_'+list[iiii].descrEmpresa+'.xlsx');
//FIN Exportar a XLS
        }
      }

      document.body.style.cursor = 'default'

      await this.props.allOrdenRtes.refetch()
      this.setState({open: false, confirmaAct: false})
    }
  } 

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false})};
    if(btnPress==="No"){
      this.setState({open: false})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      const myBtn = await document.getElementById("btnUpdDel");
      myBtn.click()
    }
  }

//   async componentDidUpdate(prevProps){
//     if(this.props.argsBuscProg!==this.state.argsBuscProg){
//       let argsBuscar=""
//       argsBuscar += `'descrEmpresa': '${this.state.argsDocum.descrEmpresa}'`
//       if(this.props.argsBuscProg.descrPlanta){
//         argsBuscar += `, 'descrPlanta': /${this.props.argsBuscProg.descrPlanta}/i`
//       }
//       if(this.props.argsBuscProg.descrSeccion){
//         argsBuscar += `, 'descrSeccion': /${this.props.argsBuscProg.descrSeccion}/i`
//       }
//       if(this.props.argsBuscProg.descrEquipo){
//         argsBuscar += `, 'descrEquipo': /${this.props.argsBuscProg.descrEquipo}/i`
//       }
//       if(this.props.argsBuscProg.descrComponente){
//         argsBuscar += `, 'descrComponente': /${this.props.argsBuscProg.descrComponente}/i`
//       }
//       if(this.props.argsBuscProg.descrMecanismo){
//         argsBuscar += `, 'descrMecanismo': /${this.props.argsBuscProg.descrMecanismo}/i`
//       }
//       if(this.props.argsBuscProg.nombreUsuario){
//         argsBuscar += `, 'nombreUsuario': /${this.props.argsBuscProg.nombreUsuario}/i`
//       }
//       argsBuscar += `, fechaReal: { $lte: new Date('${this.state.argsDocum.hasta}') }`
//       argsBuscar += `, fechaReal: { $gte: new Date('${this.state.argsDocum.desde}') }`
//       let argsBuscarPl = {tipoqry: `[{$match: {estadoOrden: 'Cerrado', realizado: 'S', ${argsBuscar}}}]`}
//       // let argsBuscarPl = {tipoqry: `[{$match: {estadoOrden: 'Cerrado'}}]`}
//       console.log(argsBuscarPl)
//       await this.props.allOrdenRtes.refetch(argsBuscarPl)
// //Cuando se usa await para que no ejecute de la siguiente linea en adelante se debe usar el resultado del await
// //por eso el if de la siguiente linea
//       if(this.props.allOrdenRtes.allOrdenRtes){
//         this.setState({argsBuscProg: this.props.argsBuscProg})
//         if(this.props.allOrdenRtes.allOrdenRtes&&prevProps.allOrdenRtes.allOrdenRtes){
//           if((this.props.allOrdenRtes.allOrdenRtes!==prevProps.allOrdenRtes.allOrdenRtes)||!this.state.list){
//             this.setState({list: 
//               this.props.allOrdenRtes.allOrdenRtes?this.props.allOrdenRtes.allOrdenRtes.map((elemento, i) => ({
//                 ...elemento, checkSeleccInf: true
//               })):[]
//             })
//             this.setState({checkSeleccInfAll: true});
//           }
//         }
//       }
//     }
//   }

  render(){
    const {list, argsDocum, checkSeleccInfAll, permiteUpdate, confirmaAct, open} = this.state;
    // const a250110 = autorizacUA.findIndex( autorizac => autorizac === "250110" );
    let mensaje = "Descargar matríz en Excel"
    let imgIcon = "images/documento_32.png"
    
    let list1 = [], list2 = []
    // if(this.props.allEmpresa.allEmpresa){list2 = this.props.allEmpresa.allEmpresa}
console.log(list.length)
    return (
      // <div>
        <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
          <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.handleSubmit(ev, list, argsDocum):()=>{}}>
            <div className="ui two column stackable grid">
              <div className="row container">
                <div className="column" style={{width: '30%', paddingLeft: '1.2em'}}>
                  <Form.Field>
                    <ListaEmp styles={this.props.styles} list={this.props.list1} handleChange={this.handleChange} />
                  </Form.Field>
                </div>

                <div className="column" style={{width: '20%'}}>
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                    Desde
                  </p>
                  <Form.Field>
                    <input style={this.props.styles.input} type='date' name="desde" id="desde" value={argsDocum.desde} onChange={this.handleChange}/>
                  </Form.Field>
                </div>
                <div className="column" style={{width: '20%'}}>
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                    Hasta
                  </p>
                  <Form.Field>
                    <input style={this.props.styles.input} type='date' name="hasta" id="hasta" value={argsDocum.hasta} onChange={this.handleChange}/>
                  </Form.Field>
                </div>
                <div className="column" style={{width: '30%', paddingTop: '0.1em'}}>
                  <SeguroPermite mensaje={mensaje} imgIcon={imgIcon} permiteUpdate={permiteUpdate} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                </div>
              </div>
            </div>
            <div>
              <div style={{height: '36em', overflow: 'auto'}}>
                <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                  <thead className=''>
                    <tr className=''>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>
                        <input style={{margin: '0.4em 0em 0em 0em'}} type='checkbox' name="checkSeleccInfAll" checked={checkSeleccInfAll} onChange={this.handleChange}/>
                      </th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '12%'}}>Operario</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Planta</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Sección</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '16%'}}>Equipo</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '18%'}}>Componente</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '18%'}}>Mecanismo</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Metodo</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Tarea</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Frecuencia</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Fecha ejec.</th>
                     </tr>
                  </thead>
                  <ListaPl list={list} handleChange={this.handleChange}/>
                </table>
                <p></p>
              </div>
            </div>
          </Form>
        </div>
      // </div>
    )
  }
};

export default compose(
  graphql(queries.query.allOrdenRtes, {name:'allOrdenRtes',
    options: (props) => {return {variables: {tipoqry: `[{$match: {descrEmpresa: 'Seleccionar Empresa...'}}]`}}}}),

  graphql(queries.query.allEmpresa, {name:'allEmpresa'}),
  graphql(queries.query.allFrecuencia, {name:'allFrecuencia'}),
  graphql(queries.mutation.fecha, {name:'fecha'}),
)(ProgInfProg2)
